<template>
  <div class="page-content">
  <div id="newAnnouncement">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>渠道政策</el-breadcrumb-item>
        <el-breadcrumb-item>通知公告</el-breadcrumb-item>
      </el-breadcrumb>
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="公告主题" :label-width="formLabelWidth">
            <el-input placeholder="请输入内容" v-model="notice_title" autocomplete="on" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="公告类型" :label-width="formLabelWidth">
            <el-select v-model="notice_type" filterable placeholder="请选择" size="small">
              <!-- <el-option label="全部" value="" ></el-option> -->
              <el-option
                v-for="item in typeData"
                :key="item.id"
                :label="item.dictName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布时间" :label-width="formLabelWidth">
            <el-date-picker
            v-model="searchformDate"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="~"
            :picker-options="pickerOptions"
            size="small">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发布人" :label-width="formLabelWidth"  v-if="type.logintype == 'HCM'" style="margin-top: -4px;">
            <el-input v-model="user_name" placeholder="请输入发布人" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item v-if="type.logintype == 'HCM'">
          </el-form-item>
          <el-form-item v-if="type.logintype != 'HCM'">
          </el-form-item>
          <el-form-item v-if="type.logintype != 'HCM'">
          </el-form-item>
          <el-form-item style="margin-top: -4px;">
            <el-button size="small" class="search-btn" @click="theQuery(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    <div class="page" v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <div class="addFont" @click="newAdd" v-show="(type.logintype == 'HCM'  || type.roleid == '23' || type.logintype == 'HCMSUB') && type.editStatus">
        <i class="el-icon-plus"></i>
        新增公告
      </div>
      <div class="noAnnouncement" v-show="tableData.length <= 0">
        <img src="../../assets/img/other/nodata.svg" style="padding-top: 20px;">
        <div style="line-height: 60px;color: #909399;">暂无公告</div>
      </div>
      <div class="divback" v-for="(item,index) in tableData" :key='index' @click="DetailsPage(item.id)">
        <div class="chengeColor">
          <div class="unread" v-show="item.isread == 0">·</div>
          {{item.notice_title}}
          <div class="istop" v-if="item.sort">
            置顶
          </div>
        </div>
        <div class="beyond">
          {{ToText(item.notice_content)}}
        </div>
        <el-row style="margin-bottom: 10px;">
          <el-col :span="18">
            <div style="display: flex;margin-left: 13px;">
              <div class="information">
                {{item.notice_typename}}<span class="segmentation">|</span>
              </div>
              <div class="information">
                {{item.createtime | formatDate}}<span class="segmentation" v-show="type.logintype == 'HCMSUB' || type.logintype == 'HCM' ">|</span>
              </div>
              <div class="information" v-show="type.logintype == 'HCMSUB' || type.logintype == 'HCM' ">
                From：{{item.user_name}}<span class="segmentation">|</span>
              </div>
              <div class="announcementTitle" v-show="item.noticeDepartsList != '' && type.logintype == 'HCMSUB' || item.noticeDepartsList != '' && type.logintype == 'HCM' ">
                To部门：<span v-for="e in item.noticeDepartsList" >{{e.depart_name}} </span>
              </div>
              <div class="announcementTitle" v-show="item.noticeClassifysList != '' && type.logintype == 'HCMSUB' && item.notice_send_type == 3 || item.noticeClassifysList != '' && type.logintype == 'HCM' && item.notice_send_type == 3 ">
                To店铺：<span v-for="e in item.noticeClassifysList" >{{e.shop_name}} </span>
              </div>
              <div class="announcementTitle" v-show="item.noticeClassifysList != '' && type.logintype == 'HCMSUB' && item.notice_send_type != 3 ||item.noticeClassifysList != '' &&type.logintype == 'HCM' && item.notice_send_type != 3">
                To品类：<span v-for="e in item.noticeClassifysList">{{e.product_classify_name}} </span>
              </div>
              <!-- <div class="announcementTitle" v-show="item.noticeClassifysList == '' && item.noticeDepartsList == '' && type.logintype == 'HCMSUB' || item.noticeClassifysList == '' && item.noticeDepartsList == '' && type.logintype == 'HCM'">
                To：所有人
              </div> -->
            </div>
          </el-col>
          <el-col :span="6" style="text-align: right;padding-right: 10px;color: #a1a1a1;" v-show="type.logintype == 'HCM'  || type.roleid == '23' || type.logintype == 'HCMSUB'">
            <i class="el-icon-upload2" @click="stick(item.id,1,item.sort)" @click.stop style="padding-right: 25px;" v-if ="!item.sort">置顶</i>
            <i class="el-icon-download" @click="stick(item.id,2,item.sort)" @click.stop style="padding-right: 25px;" v-else>取消置顶</i>
            <i class="el-icon-delete" @click="elcDelete(item.id)" @click.stop>删除</i>
          </el-col>
        </el-row>
      </div>
      <el-dialog
        title="提示"
        :visible.sync="deleteShow"
        width="20%" style="margin-top: 10%;">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
           <div>
               <div style="font-size: 16px;">你确认要删除该通知公告吗？</div>
               <div style="font-size: 14px;">删除后
               <span style="color: #e90e24;font-size: 14px;">相关人员将不再能看到该公告</span>
            </div>
           </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="deleteClassification" size="small" >确 定</el-button>
          <el-button @click="deleteShow = false" size="small" type="TheCustom" style="margin-left: 10px;">取 消</el-button>
        </span>
      </el-dialog>
      <div v-show="this.tableData.length >= 1">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
  </div>
</div>

</template>

<script>
  import aes from "../../libs/aes";
  import pagination from "../../components/dataTable/pagination";
  export default {
    data() {
      return {
        tableLoading: false,
        companyname: '',
        pageNo: 1,
        currentPage: 1,
        pageSize: 10,
        tableData: [],
        typeData: [],
        searchformDate: [],
        pickerOptions: {
  				shortcuts: [{
            text: '今日',
            onClick:(picker) => {
  						this.getRecentDate(picker,1);
  					}
          },{
            text: '近7日',
            onClick:(picker) => {
  						this.getRecentDate(picker,7);
  					}
          }, {
  					text: '近15日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,15);
  					}
  				}, {
  					text: '近30日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,30);
  					}
  				}, {
  					text: '近90日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,90);
  					}
  				}, {
  					text: '近365日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,365);
  					}
  				}]
  			},
        totalNum: 100,
        formLabelWidth: '100px',
        notice_type: '',
        notice_title: '',
        user_name: '',
        deleteShow: false,
        type: '',
      }
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    created(){
  		this.getRecentDate();
  	},
    mounted() {
      this.type = JSON.parse(window.localStorage.userData)
      console.log(this.type.logintype)
      this.theQuery();
      this.announcementType();
    },
    methods: {
      ToText(HTML) {
        if (HTML == null) {

        } else {
          var notice_content = HTML;
          return notice_content.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ');
          // .replace(/[ ]|[&nbsp;]/g,' ')
        }

      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = `${val}`
        this.theQuery()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageNo = `${val}`
        this.theQuery()
      },
      elcDelete(e) {
        this.deleteShow = true;
        this.notice_id = e;
      },
      stick(e,f,h) {
        let params={}
        if (f == 1) {
          params.id = e
          if (h != 1) {
            params.sort = 1
          } else {
            params.sort = h
          }
        } else {
          params.id = e
          params.sort = 0
        }
        fetch({
          url: "hcm/notice/updateNoticesort ",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.theQuery()
          }
        })
      },
      deleteClassification() {
        let params={
          notice_id: this.notice_id
        }
        fetch({
          url: "hcm/notice/Delete",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.deleteShow = false;
            this.theQuery();
          }
        })
      },
      DetailsPage(e) {
        console.log(e)
        this.$router.push({
          path: '/AnnouncementDetails',query: {e}
        })
      },
      newAdd() {
        this.$router.push({
          path: '/newAddAnnouncement'
        })
      },
      // 前三个月时间
  		getRecentDate(picker,n){
        if (!n) {
          n = 90
        }
  			const end = new Date();
  			const start = new Date();
  			start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
  			if(picker){
  				picker.$emit('pick', [start, end]);
        }
        this.searchformDate[0] = start;
        this.searchformDate[1] = end;
  		},
      theQuery(e) {
        this.tableLoading = true
        if (e == 1) {
          this.pageNo = 1
          this.currentPage = 0
        }
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          start_time: this.$options.filters['fullTime'] (this.searchformDate[0]),
          end_time: this.$options.filters['fullTime'] (this.searchformDate[1]),
        }
        if (this.notice_type) {
          params.notice_type = this.notice_type
        }
        if (this.notice_title) {
          params.notice_title = this.notice_title
        }
        if (this.user_name) {
          params.user_name = this.user_name
        }
        fetch({
          url: "hcm/notice/Getlist",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.currentPage = 1
            this.tableData = data.content;
            this.totalNum = data.totalElements;
            this.tableLoading = false
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      announcementType() {
        let params={
          dictcode: 'notice_type',
        }
        fetch({
          url: "hcm/sys/GetList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.typeData = data;
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
    },
    components: {
        pagination
    }
  }
</script>
<style scoped lang="scss">
  .page {
    padding: 20px;
    margin: 10px 0px 0px 0px;
    background-color: white;
  }
  .announcementTitle {
    margin-right: 20px;
    height: 15px;
    line-height: 15px;
    color: #a1a1a1;
    width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .noAnnouncement {
    border-bottom: 1px solid #e8ebec;
    margin-top: 25px;
    height: 133px;
    text-align: center;
  }
  .istop {
    width: 36px;
    height: 16px;
    color: white;
    background-color: #108cee;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    border-radius: 2px;
    margin-top: 7px;
    margin-left: 5px;
    margin-right: 5px;
    float: left;
  }
  .beyond {
    padding-top: 25px;
    margin-left: 13px;
    color: #8c8c8c;
    padding-bottom: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 70%;
  }
  .information {
    margin-right: 20px;
    height: 15px;
    line-height: 15px;
    color: #a1a1a1;
    width: auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

  }
  .unread {
    color: red;
    font-size: 20px;
    font-weight: 900;
    line-height: 27px;
    margin-right: 7px;
    float: left;
  }
  .segmentation {
    margin-left: 20px;
    font-weight: 100;
  }
  .divback {
    border-bottom: 1px solid #e8ebec;
    padding-top: 25px;
    cursor:pointer;
  }
  .divback:hover {
    background-color: #f3f9fe;
    border-bottom: 1px solid #e8ebec;
    padding-top: 25px;
    cursor:pointer;
    // opacity: 0.1;
  }
  .headerSize {
    line-height: 32px;
    text-align: right;
  }
  .addFont {
    color: #108cee;
    font-weight: bold;
    text-align: center;
    border: 1px dashed #e8ebec;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }
  .addFont:hover {
    border: 1px dashed #108cee;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .chengeColor {
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    margin-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 70%;
  }
  .chengeColor:hover {
    color: #108cee;
  }
  .el-icon-upload2:hover {
    color: #108cee;
  }
  .el-icon-download:hover {
    color: #108cee;
  }
  .el-icon-delete:hover {
    color: #108cee;
  }
</style>
<style lang="scss">
#newAnnouncement {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
  .el-button--primary {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
</style>
